import { useApolloClient, useSubscription } from '@apollo/client/react'
import {
  GetAlertsDocument,
  SubscriptionAlertCreatedDocument,
} from 'src/apollo/generated/graphql'

export const useSubscriptionAlertCreated = () => {
  const client = useApolloClient()

  useSubscription(SubscriptionAlertCreatedDocument, {
    onData: ({ data: { data } }) => {
      if (!data?.alertCreated) return

      client.refetchQueries({ include: [GetAlertsDocument] })
    },
  })

  return {}
}
